module.exports = __webpack_public_path__ + "static/the-paradox-of-choice-4b020768716004fe3529c309338c10b0.jpg";